import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
// tslint:disable-next-line:max-line-length
import { ConfiguracaoIntegracaoBandeiraComponent } from './configuracao/configuracao-integracao/configuracao-integracao-bandeira/configuracao-integracao-bandeira.component'
// tslint:disable-next-line:max-line-length
import { ConfiguracaoIntegracaoOperadoraComponent } from './configuracao/configuracao-integracao/configuracao-integracao-operadora/configuracao-integracao-operadora.component'
import { ConfiguracaoIntegracaoComponent } from './configuracao/configuracao-integracao/configuracao-integracao.component'
// tslint:disable-next-line:max-line-length
import { ConfiguracaoIntegracaoCollectPorBandeiraResolver } from './configuracao/shared/configuracao-integracao-collect-por-bandeira.resolver'
// tslint:disable-next-line:max-line-length
import { ConfiguracaoIntegracaoConciliadorWCONTResolver } from './configuracao/shared/configuracao-integracao-conciliador-wcont.resolver'
import { CanActivateColaboradorRouteGuard } from './core/guards/can-activate-colaborador-route.guard'
import { EmpresasAtivasResolver } from './core/resolvers/empresas-ativas.resolver'
import { OperadorasComEstabelecimentoResolver } from './core/resolvers/operadoras-com-estabelecimento.resolver'
import { TodasBandeirasResolver } from './core/resolvers/todas-bandeiras.resolver'
import { TodasEmpresasQVCCResolver } from './core/resolvers/todas-empresas-qvcc.resolver'
import { TodasOperadorasResolver } from './core/resolvers/todas-operadoras.resolver'
import { EstabelecimentosComponent } from './estabelecimentos/estabelecimentos.component'
import { EstabelecimentosResolver } from './estabelecimentos/shared/estabelecimentos.resolver'
import { TotalDeEstabelecimentosCarentesResolver } from './estabelecimentos/shared/total-de-estabelecimentos-carentes.resolver'
import { ExtratosComponent } from './extratos/extratos.component'
import { OpcoesRelatorioResolver } from './extratos/relatorio/opcoes-relatorio.resolver'
import { RelatorioComponent } from './extratos/relatorio/relatorio.component'
import { DadosIniciaisExtratosResolver } from './extratos/shared/dados-iniciais-extratos.resolver'
import { OperadorasInativasResolver } from './estabelecimentos/shared/operadoras-inativas.resolver'
import { CanActivateExtratoRouteGuard } from './core/guards/can-activate-extrato-route.guard'
import { CanActivateEstabelecimentoRouteGuard } from './core/guards/can-activate-estabelecimento-route.guard'

const routes: Routes = [
    { path: '', redirectTo: '/extratos', pathMatch: 'full' },
    {
        path: 'extratos',
        component: ExtratosComponent,
        canActivate: [CanActivateExtratoRouteGuard],
        data: { title: 'Extrato de vendas' },
        resolve: {
            dadosIniciais: DadosIniciaisExtratosResolver,
        },
    },
    {
        path: 'extratos/relatorio',
        component: RelatorioComponent,
        data: { title: 'Relatório Collect' },
        canActivate: [CanActivateExtratoRouteGuard],
        resolve: {
            opcoesRelatorio: OpcoesRelatorioResolver,
        },
    },
    {
        path: 'configuracao-integracao',
        component: ConfiguracaoIntegracaoComponent,
        data: { title: 'Configuração de Integração' },
        canActivate: [CanActivateColaboradorRouteGuard],
        resolve: {
            configuracaoIntegracaoPorBandeira:
                ConfiguracaoIntegracaoCollectPorBandeiraResolver,
            todasOperadoras: TodasOperadorasResolver,
            operadorasComEstabelecimento: OperadorasComEstabelecimentoResolver,
            todasBandeiras: TodasBandeirasResolver,
            configuracao: ConfiguracaoIntegracaoConciliadorWCONTResolver,
        },
        children: [
            {
                path: 'operadora',
                component: ConfiguracaoIntegracaoOperadoraComponent,
                data: { title: 'Configuração de Integração' },
            },
            {
                path: 'bandeira',
                component: ConfiguracaoIntegracaoBandeiraComponent,
                data: { title: 'Configuração de Integração' },
            },
        ],
    },
    {
        path: 'estabelecimentos',
        component: EstabelecimentosComponent,
        data: { title: 'Estabelecimentos' },
        canActivate: [CanActivateEstabelecimentoRouteGuard],
        resolve: {
            todasOperadoras: TodasOperadorasResolver,
            operadorasInativas: OperadorasInativasResolver,
            empresasAtivas: EmpresasAtivasResolver,
            estabelecimentos: EstabelecimentosResolver,
        },
    },
]

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [
        TodasOperadorasResolver,
        OperadorasComEstabelecimentoResolver,
        ConfiguracaoIntegracaoConciliadorWCONTResolver,
        TodasEmpresasQVCCResolver,
        TotalDeEstabelecimentosCarentesResolver,
        EmpresasAtivasResolver,
        ConfiguracaoIntegracaoCollectPorBandeiraResolver,
        TodasBandeirasResolver,
        OpcoesRelatorioResolver,
        EstabelecimentosResolver,
        DadosIniciaisExtratosResolver,
        CanActivateColaboradorRouteGuard,
        CanActivateEstabelecimentoRouteGuard,
        CanActivateExtratoRouteGuard,
        OperadorasInativasResolver,
    ],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts